import React from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import SelectionInput from '../../common/SelectionInput';
import { toast } from 'react-toastify';

const MagazineSurveyModal = ({
  surveySearch,
  selectedSurvey,
  activeSurveyDropdown,
  surveyList,
  magazineSurveyList,
  handleSurveySearch,
  handleSurveySelect,
  handleCreateMagazineSurvey,
  clearSelections
}) => {
  return (
    <div className="p-4">
      <h5 className="text-primary mb-3">Create Magazine Survey</h5>

      <SelectionInput
        label="Please select the survey"
        placeholder="Search Survey"
        value={surveySearch || selectedSurvey?.title}
        onSearch={handleSurveySearch}
        onSelect={handleSurveySelect}
        onClear={clearSelections}
        results={surveyList.surveys}
        isActive={activeSurveyDropdown}
        magazineSurveyList={magazineSurveyList}
        onFocus={() => handleSurveySearch(surveySearch)}
      />
      <Button
        color="primary"
        onClick={() => {
          if (!selectedSurvey?._id) {
            toast.error("Please select the survey");
            return;
          }
          handleCreateMagazineSurvey();
        }}
      >
        Create Magazine Survey
      </Button>
    </div>
  );
};

export default MagazineSurveyModal; 